import React, { useCallback } from "react";
import type { FieldValues, UseControllerProps } from "react-hook-form";
import type { RoleType } from "client/api/RolesApi";
import { getRoles } from "client/api/RolesApi";
import { EntitySelector } from "../EntitySelector/EntitySelector";

type RoleSelectorProps<T extends FieldValues> = UseControllerProps<T> & {
  label?: string;
  roleType: RoleType;
};

export function RoleSelector<T extends FieldValues>(props: RoleSelectorProps<T>) {
  const { label, roleType, ...rest } = props;

  const apiRequest = useCallback(() => {
    return getRoles({
      filter: {
        RoleType: {
          eq: roleType,
        },
      },
    });
  }, [roleType]);

  return (
    <EntitySelector {...rest} label={label || "Role"} apiRequest={apiRequest} optionLabelFunc={(role) => role.name} />
  );
}
